import { Grid, Typography } from "@mui/material";
import { useState } from "react";

export default function Test() {

    const [change, setchange] = useState(false);

    return (
        <>

            <Grid container justifyContent={'center'} height={'100vh'} alignItems={'center'}>
                <Grid size={{ lg: 9 }} container>
                    <div className="auth-cont">
                        <Grid sx={{ transform: `translateX(${change && '100%'})` }} className="go-to-login">
                            <Typography>Go to Login </Typography>
                            <button className="btn btn-info">Change</button>
                        </Grid>
                        <Grid className="go-to-reg" sx={{ transform: `translateX(${change && '-100%'})` }}>
                            <Typography>Go to register </Typography>
                            <button className="btn danger" onClick={() => setchange(!change)}>Change</button>
                        </Grid>
                    </div>
                </Grid>
            </Grid>

        </>
    )
}